import { Route } from "react-router-dom";
import { ROUTES } from "../config/routes";
import BasicDetails from "../pages/recruitment/onboarding/basic-details/BasicDetails";
import RecruitmentLanding from "../pages/recruitment/recruitment-landing/RecruitmentLanding";
import SuccessOnboarding from '../pages/recruitment/Components/success-onboarding/SuccessOnboarding'
import RequireAuth from "../components/required-auth/RequiredAuth";
import LeanLayout from "../layouts/lean-layout/LeanLayout";

const recruitmentLandingPath = `${ROUTES.RECRUITMENT}/${ROUTES.ONBOARDING}`
export default (
  <Route path={recruitmentLandingPath} element={<LeanLayout />}>
    <Route index element={<RecruitmentLanding />} />
    <Route element={<RequireAuth navigateTo={ recruitmentLandingPath} />}>
      <Route path={ROUTES.BASIC_DETAILS} element={<BasicDetails />} />
      <Route path={ROUTES.ONBOARDING_SUCCESS} element={<SuccessOnboarding />} />
    </Route>
  </Route>
)